import type { MantinePrimaryShade } from "@mantine/core";
import { useComputedColorScheme, useMantineTheme } from "@mantine/core";

export function usePrimaryShade() {
  const theme = useMantineTheme();
  const computedColorScheme = useComputedColorScheme("light");
  const primaryShade = theme.primaryShade as MantinePrimaryShade;
  return primaryShade[computedColorScheme];
}
